var map = {
	"./super-admin/layout/header/style.scss": 31113,
	"./super-admin/layout/menu/style.scss": 38815,
	"./super-admin/stylesheets/variables.scss": 4350,
	"./table/variables.scss": 61153,
	"@kaspernj/api-maker/src/super-admin/layout/header/style.scss": 31113,
	"@kaspernj/api-maker/src/super-admin/layout/menu/style.scss": 38815,
	"@kaspernj/api-maker/src/super-admin/stylesheets/variables.scss": 4350,
	"@kaspernj/api-maker/src/table/variables.scss": 61153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73999;